import * as ActionTypes from 'state/types'
import { getCustomer, getFullName } from 'shared/utils/helper'
import moment from 'moment'

const initialState = {
   interaction: null,
   profile: {
      customerId: '',
      fullName: '',
      firstName: '-',
      lastName: '-',
      firstActivity: '-',
      lastActivity: '-',
      isRequesting: false,
      isFailure: false
   },
   isEventTriggerRequesting: false,
   triggerEvents: [],
   inbox: null,
   filter: null,
   deletionFlag: false
}

export default (state = initialState, action) => {
   switch (action.type) {
      case ActionTypes.RECEIVE_UPDATED_INTERACTION: {
         const { archived, interactionId } = action.interaction
         if(interactionId === state.interaction?.interactionId && archived && state?.filter !== 'archived' ) {
            return {
               ...state,
               interaction: null
            }
         }
         return state
      }

      case ActionTypes.SELECT_INTERACTION: {
         const interaction = action.payload
         const customer = getCustomer(interaction)
         return {
            ...state,
            interaction,
            profile: {
               ...state.profile,
               customerId: customer?._id,
               fullName: getFullName(interaction),
               firstName: customer?.profile?.firstName || '-',
               lastName: customer?.profile?.lastName || '-',
               email: customer?.profile?.email || '-',
               gender: customer?.profile?.gender || '-',
               locale: customer?.profile?.locale || '-',
               timezone: customer?.profile?.timezone || '-',
               phoneNumber: customer?.profile?.phoneNumber || '-'
            },
            triggerEvents: []
         }
      }
      case ActionTypes.RECEIVE_ACTIVITY: {
         const { interactionId, createdAt } = action.activity

         if (interactionId === state.interaction.interactionId) {
            let updatedDate
            const { lastActivity } = state.profile
            const fetchedLastDate = new Date(createdAt)
            if (lastActivity !== '-' && createdAt) {
               const currentLastDate = new Date(lastActivity)
               updatedDate = (currentLastDate.getTime() < fetchedLastDate.getTime()) ? fetchedLastDate : currentLastDate
            } else {
               updatedDate = fetchedLastDate
            }
            return {
               ...state,
               profile: {
                  ...state.profile,
                  lastActivity: updatedDate ? moment(updatedDate).format('LLL') : '-'
               }
            }
         }
         return state
      }
      case `${ActionTypes.GET_ACTIVITIES_DATES_REQUEST}_START`:
         return {
            ...state,
            profile: {
               ...state.profile,
               isRequesting: true,
               isFailure: false
            }
         }

      case `${ActionTypes.GET_ACTIVITIES_DATES_REQUEST}_SUCCESS`: {
         const {
            first,
            last
         } = action.response.payload

         return {
            ...state,
            profile: {
               ...state.profile,
               isRequesting: false,
               firstActivity: (first && state.profile.customerId) ? moment(first).format('LLL') : '-',
               lastActivity: (last && state.profile.customerId) ? moment(last).format('LLL') : '-'
            }
         }

      }

      case `${ActionTypes.GET_ACTIVITIES_DATES_REQUEST}_FAIL`:
         return {
            ...state,
            profile: {
               ...state.profile,
               isRequesting: false,
               isFailing: true
            }
         }

      case `${ActionTypes.INTERACTION_INFO_REQUEST}_SUCCESS`: {
         const newInteraction = action.response.payload

         if (!newInteraction) return state

         if (state.isUnassign) return { ...state, isUnassign: false }

         return {
            ...state,
            interaction: newInteraction,
            triggerEvents: []
         }
      }

      case ActionTypes.SELECT_INBOX: {
         return {
            ...state,
            inbox: action.payload.inbox,
            filter: null,
            interaction: null,
            profile: {
               customerId: '',
               fullName: '',
               firstName: '-',
               lastName: '-',
               firstActivity: '-',
               lastActivity: '-',
               isRequesting: false,
               isFailure: false
            },
            deletionFlag: false
         }
      }
      case ActionTypes.SELECT_FILTER: {
         return {
            ...state,
            inbox: null,
            interaction: null,
            filter: action.payload.filter,
            profile: {
               customerId: '',
               fullName: '',
               firstName: '-',
               lastName: '-',
               firstActivity: '-',
               lastActivity: '-',
               isRequesting: false,
               isFailure: false
            }
         }
      }

      case `${ActionTypes.ASSIGN_INTERACTION_REQUEST}_SUCCESS`:
         if (state.filter === null) {
            return {
               ...state,
               interaction: null
            }
         } else return {
            ...state,
            interaction: action.response.payload
         }

      case `${ActionTypes.UNASSIGN_INTERACTION_REQUEST}_SUCCESS`:
         debugger
         if (state.filter === 'assignee') {
            return {
               ...state,
               isUnassign: true,
               interaction: null
            }
         } else {
            return {
               ...state,
               interaction: action.response.payload
            }
         }


      case `${ActionTypes.TRIGGER_EVENTS_REQUEST}_SUCCESS`:
         return {
            ...state,
            triggerEvents: action.response.items
         }

      case ActionTypes.RECEIVE_DELETED_INTERACTION: {

         if (!state.interaction || state.interaction.interactionId !== action.interaction.interactionId) {
            return state
         }
         return {
            ...state,
            interaction: null,
            triggerEvents: []
         }
      }

      case `${ActionTypes.ARCHIVE_INTERACTION_REQUEST}_SUCCESS`:
      case `${ActionTypes.UNARCHIVE_INTERACTION_REQUEST}_SUCCESS`:
         return {
            ...state,
            interaction: null
         }

      case `${ActionTypes.TRIGGER_EVENT_REQUEST}_START`: {
         return {
            ...state,
            isEventTriggerRequesting: true
         }
      }

      case `${ActionTypes.TRIGGER_EVENT_REQUEST}_SUCCESS`:
      case `${ActionTypes.TRIGGER_EVENT_REQUEST}_FAIL`: {
         return {
            ...state,
            isEventTriggerRequesting: false
         }
      }


      default:
         return state
   }
}
